import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import Account from 'src/pages/Account';

import CustomerList from 'src/pages/CustomerList';
import StockTransferList from 'src/pages/StockTransferList';
import Dashboard from 'src/pages/Dashboard';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import ProductList from 'src/pages/ProductList';
import Register from 'src/pages/Register';
import Settings from 'src/pages/Settings';
import NotificationKoalaPage from './pages/NotificationKoalaPage';
import InvoiceVarifyList from './pages/InvoiceVarifyList';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import AddNewExtraChargesPage from './pages/AddNewExtraChargesPage';


const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <Account /> },
      { path: 'customers', element: <CustomerList /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'products', element: <ProductList /> },
      { path: 'settings', element: <Settings /> },
      { path: 'notificationDetail/:id', element: <NotificationKoalaPage /> },
      { path: '*', element: <Navigate to="/404" /> },
      { path: 'stocktransfer', element: <StockTransferList /> },
      { path: 'invoicevarifylist', element: <InvoiceVarifyList /> },
      { path: 'invoicedetailpage', element: <InvoiceDetailPage /> },
      { path: 'addnewextracharges', element: <AddNewExtraChargesPage /> }

    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
